module.exports = __webpack_public_path__ + "static/img/仪器信息网.51137dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/meiti-index/仪器信息网.png
// module id = rbEx
// module chunks = 1